// The SPARKLINE visual of a home widget (HOME_WIDGETS_SPEC.md §2): a 2 px
// stroke in the widget hue over an 8% area. Data-driven, so an inline SVG —
// a chart, not an icon (Rule 62 is about icons; the BI revenue body draws its
// trend the same way).
//
//   HomeWidgetSpark: { points: (el, s) => el.call('comRevenueByHour', s.root) }
//
// Geometry comes from `homeSparkGeom` (functions/homeWidgetVisuals.js). Fewer
// than two points = not read yet: a skeleton block fills the same box. Hidden
// at S (spec: an S widget keeps only a progress as its visual).
export const HomeWidgetSpark = {
  class: 'home-widget-visual',
  gridArea: 'visual',
  display: 'none',
  ':is([data-widget-size]:not([data-widget-size="s"])) &': {
    display: 'block'
  },
  position: 'relative',
  alignSelf: 'stretch',
  minHeight: 'C',
  minWidth: '0',
  // L stacks the slots and its visual track is `auto` (the list takes the
  // rest): the chart is absolutely placed, so it keeps its OWN height there —
  // a 3:1 box, never less than C — instead of filling a track that has none.
  ':is([data-widget-size="l"]) &': { alignSelf: 'start', aspectRatio: '3 / 1' },
  color: '--home-widget-accent',
  points: null,

  Chart: {
    // frank-allow FA601 — data sparkline (non-icon viewBox), not an icon
    tag: 'svg',
    viewBox: '0 0 120 36',
    attr: { preserveAspectRatio: 'none', 'aria-hidden': 'true' },
    position: 'absolute',
    inset: '0',
    width: '100%',
    height: '100%',
    display: 'block',
    overflow: 'visible',
    hide: (el) => !el.call('homeSparkGeom', el.parent.points, 120, 36, 3),

    Area: {
      // frank-allow FA602 — computed sparkline area, not an icon
      tag: 'path',
      attr: {
        d: (el) =>
          (el.call('homeSparkGeom', el.parent.parent.points, 120, 36, 3) || {}).areaPath || null,
        fill: 'currentColor',
        'fill-opacity': '0.08',
        stroke: 'none'
      }
    },
    Line: {
      // frank-allow FA602 — computed sparkline stroke, not an icon
      tag: 'path',
      attr: {
        d: (el) =>
          (el.call('homeSparkGeom', el.parent.parent.points, 120, 36, 3) || {}).linePath || null,
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linejoin': 'round',
        'stroke-linecap': 'round',
        'vector-effect': 'non-scaling-stroke'
      }
    }
  },

  Skeleton: {
    position: 'absolute',
    inset: '0',
    width: 'auto',
    height: 'auto',
    round: 'radiusControl',
    hide: (el) => !!el.call('homeSparkGeom', el.parent.points, 120, 36, 3)
  }
}
